export default __webpack_public_path__ + "static/media/arrow_forward.18c8e339.svg";